module.exports = __webpack_public_path__ + "img/Engel.becd1752.jpg";